export default __webpack_public_path__ + "static/media/logo.b4594db0.png";